export default __webpack_public_path__ + "static/media/79_photo.4d7d678a.jpg";